import {sanityClient} from "./sanityClient";

export const siteContentQuery = `
  *[_type == "siteContent" && _id == "site-content"][0] {
    company,
    home {
      ...,
      "heroImage": coalesce(heroImage.asset->url, heroImageUrl),
      "aboutImage": coalesce(aboutImage.asset->url, aboutImageUrl)
    },
    about,
    capabilities[] {
      title,
      description,
      "image": coalesce(image.asset->url, imageUrl)
    },
    industries[] {
      name,
      "image": coalesce(image.asset->url, imageUrl),
      clients,
      services
    },
    clients,
    whyUs,
    milestones,
    seoPages
  }
`;

export async function getSiteContent() {
  const content = await sanityClient.fetch(siteContentQuery);

  if (!content) {
    return null;
  }

  return {
    ...content,
    pageSeo: Object.fromEntries(
      (content.seoPages || []).map((item) => [
        item.page,
        {
          title: item.title,
          description: item.description,
          canonical: item.canonical,
        },
      ]),
    ),
  };
}
